import assessmentsApi from "./slices/assessments";

export const {
	useGetAssessmentsQuery,
	useGetActiveLiveSessionIdsQuery,
	useRegisterForLiveSessionMutation,
	useUnregisterForLiveSessionMutation,
} = assessmentsApi;
